import { render } from "./edit-testimonials.vue?vue&type=template&id=7d434e90"
import script from "./edit-testimonials.vue?vue&type=script&lang=js"
export * from "./edit-testimonials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__